import React from "react";
import { Button, Icon, Input } from "rhombus-react";
import { useTooltipRebuild } from "hooks/useTooltipRebuild";

import "./FileInputWithBrowse.css";

export const FileInputWithBrowse = (props) => {
	const { removeDataTip, maxSize, ...domProps } = props;
	useTooltipRebuild([removeDataTip]);
	const fileInputRef = React.useRef(null);
	const error = props.meta?.error;

	const handleBrowseClick = () => {
		fileInputRef.current.click();
	};

	const readFileAsBase64 = (file) => {
		const reader = new FileReader();
		reader.onload = () => {
			props.input.onChange({
				filename: file.name,
				base64: reader.result,
				filesize: file.size,
			});
		};
		reader.readAsDataURL(file);
	};

	const handleFileChange = (event) => {
		const [file] = event.target.files;
		if (file) {
			if (file.size > maxSize) {
				props.input.onChange({
					filename: file.name,
					base64: "",
					filesize: file.size,
				});
			} else {
				readFileAsBase64(file);
			}
		}
	};

	const handleFileRemoval = () => {
		if (fileInputRef.current) {
			fileInputRef.current.value = "";
		}
		props.input.onChange({
			filename: "",
			base64: "",
			filesize: 0,
		});
	};

	return (
		<div
			className={`file-input-container logo-input ${props.className}`}
			data-testid="file-input-container"
		>
			<input
				{...domProps}
				ref={fileInputRef}
				type="file"
				onChange={handleFileChange}
				accept={props.accept || "image/*"}
				className={`hidden-file-input`}
				data-testid="file-input-non-visible"
			/>
			<div className={`file-input-display ${!!error && "e-form--error"}`} data-testid={"file-input-display"}>
				<Input
					{...domProps}
					type="text"
					placeholder={props.placeholder}
					value={props.input.value?.filename || ""}
					onClick={handleBrowseClick}
					className={`logo-input ${props.readOnly ? 'readonly' : ''}`}
					readOnly
					hasError={!!error}
				/>
				{
					props.input.value?.filename && !props.readOnly && (
						<span
							className="file-input-removal"
							data-tip={removeDataTip || "Remove file"}
							onClick={handleFileRemoval}
							data-testid="remove-file-button"
						>
							<Icon name="fas fa-close" />
						</span>
					)
				}
				<div
					className={"browse-button-container"}
				>
					<Button
						onClick={handleBrowseClick}
						disabled={props.readOnly}
						data-testid={"browse-button"}
					>
						Browse
					</Button>
				</div>
			</div>
			{!!error && (
				<div className="e-form__control-wrapper e-form--has-message file-input-error-wrapper">
					<div className="file-input-error warning-message has-errors" data-testid="file-input-error">
						{error}
					</div>
				</div>
			)}
		</div>
	);
};

FileInputWithBrowse.displayName = "FileInputWithBrowse";
